import React, { useCallback, type JSX } from 'react';
import {
  ApolloError,
  gql,
  MutationFunction as MutationFn,
  MutationResult,
  useMutation,
} from '@apollo/client';

import { IUIUrval } from '../../Types/UrvalTypes';

export const createDeleteOrUndeleteMutation = (
  collectionName?: string,
  database?: string,
  id?: string,
  action?: 'Delete' | 'Undelete',
  version?: number
): string => {
  const args = `(values:{id: "${id}", _version: ${version}})`;
  return `mutation ${action}Mutation {
    db(name: "${database}") {
      ${collectionName}_${action}${args} {
        id
        _version
        BORTTAGEN
      }
    }
  }`;
};

export interface IMutationProp {
  collectionName?: string;
  dbName: string;
  id: string | null;
  version: number;
  urval: IUIUrval;
  onCompleted?: () => void;
  onError?: (error: ApolloError) => void;
  children: (mutate: MutationFn, result: MutationResult) => JSX.Element;
}

export interface IDeleteMutationSettings {
  collectionName?: string;
  dbName?: string;
  id: string | null;
  version?: number;
  urval?: IUIUrval;
  onCompleted?: () => void;
  onError?: (error: ApolloError) => void;
}

export const useDeleteMutation = (
  props: IDeleteMutationSettings,
  action: 'Delete' | 'Undelete'
): React.DispatchWithoutAction => {
  const mutation = gql`
    ${createDeleteOrUndeleteMutation(
      props.collectionName,
      props.dbName,
      props.id ?? undefined,
      action,
      props.version
    )}
  `;

  const [mutate] = useMutation(mutation);
  const deleteFuntion = useCallback(() => {
    mutate();
  }, [mutate]);
  return deleteFuntion;
};
